interface PaginationProps {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
}

export default function Pagination({ page, pageSize, total, onPageChange }: PaginationProps) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  if (totalPages <= 1) {
    return null;
  }

  const start = Math.max(1, Math.min(page - 2, totalPages - 4));
  const pageNumbers: number[] = [];
  for (let index = start; index < start + 5 && index <= totalPages; index += 1) {
    pageNumbers.push(index);
  }

  const baseButton =
    "flex h-10 min-w-10 items-center justify-center rounded-md border px-3 text-sm font-semibold transition-colors duration-200";

  return (
    <nav className="mt-10 flex items-center justify-center gap-2" aria-label="Pagination">
      <button
        type="button"
        onClick={() => onPageChange(page - 1)}
        disabled={page <= 1}
        className={`${baseButton} cursor-pointer border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-arrow-left-s-line text-lg" />
        </span>
      </button>

      {pageNumbers.map((number) => (
        <button
          key={number}
          type="button"
          onClick={() => onPageChange(number)}
          aria-current={number === page ? "page" : undefined}
          className={`${baseButton} cursor-pointer ${
            number === page
              ? "border-primary-500 bg-primary-500 text-background-50"
              : "border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
          }`}
        >
          {number}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onPageChange(page + 1)}
        disabled={page >= totalPages}
        className={`${baseButton} cursor-pointer border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40`}
      >
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-arrow-right-s-line text-lg" />
        </span>
      </button>
    </nav>
  );
}